import Confetti from "react-confetti";

export default function Main(props) {
  const randomDice = props.dice.map((item) => (
    <button
      onClick={() => props.toggleId(item.id)}
      className={
        item.isHeld ? "bg-blue-900 m-3 p-5 rounded" : "bg-white m-3 p-5 rounded"
      }
      key={item.id}
    >
      {item.value}
    </button>
  ));

  return (
    <div className="bg-sky-900 min-h-screen font-sans flex justify-center items-center">
      <div className="bg-gray-500 flex flex-col jusfity-center items-center w-5/6 h-3/4 rounded-3xl">
        {props.tenzies && <Confetti />}
        <h1 className="text-2xl font-bold p-12">Tenzies</h1>
        <h2 className="pb-8 w-3/4 text-center font-medium sm:w-1/2">
          Roll until all dice are the same. Click each die to freeze it at its
          current value between rolls.
        </h2>
        <h1 className="grid grid-cols-5">{randomDice}</h1>
        <button>
          <button
            className="text-white font-bold px-6 py-2 mt-8 mx-4 bg-blue-900 rounded-2xl  hover:bg-blue-500"
            onClick={props.handleClick}
          >
            {props.tenzies ? "New Game" : "Roll"}
          </button>
          {!props.tenzies && (
            <button
              onClick={props.resetGame}
              className="text-white font-bold px-6 py-2 mt-4 mx-4 bg-blue-900 rounded-2xl hover:bg-blue-500"
            >
              Reset Game
            </button>
          )}
        </button>
        <h3 className="m-4 font-medium">
          Time: {props.formatTime(props.startTime)}
        </h3>
        <h3 className="m-4 font-medium">No of Rolls: {props.rollNo}</h3>
      </div>
    </div>
  );
}
